import { Directive, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[appOnlyNumbersWhitTwoDecimal]',
})
export class OnlyNumbersWhitTwoDecimalDirective {
  private regex: RegExp = new RegExp(/^(-)?\d+(\.\d{0,2})?$/g);
  private specialKeys: Array<string> = [
    'Backspace',
    'Tab',
    'End',
    'Home',
    'ArrowLeft',
    'ArrowRight',
    'Delete',
  ];

  constructor(private ngControl: NgControl) {}

  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    if (this.specialKeys.indexOf(event.key) !== -1) {
      return;
    }

    const current: string = String(this.ngControl.control?.value ?? '');
    const next: string = current.concat(event.key);

    if (event.key === '-' && current.length === 0) {
      return;
    }
    if (next && !String(next).match(this.regex)) {
      event.preventDefault();
    }
  }

  @HostListener('paste', ['$event'])
  onPaste(event: ClipboardEvent) {
    const clipboardData = event.clipboardData?.getData('text') || '';
    if (!String(clipboardData).match(this.regex)) {
      event.preventDefault();
    }
  }

  @HostListener('input', ['$event'])
  onInput(event: Event) {
    const input = event.target as HTMLInputElement;
    const sanitized = this.sanitize(input.value);

    if (sanitized === input.value) {
      return;
    }

    setTimeout(() => {
      input.value = sanitized;
      this.ngControl.control?.setValue(sanitized);
    });
  }

  private sanitize(value: string): string {
    const negative = value.startsWith('-') ? '-' : '';
    let digitsAndDot = value.replace(/[^\d.]/g, '');

    const firstDot = digitsAndDot.indexOf('.');
    if (firstDot !== -1) {
      digitsAndDot =
        digitsAndDot.slice(0, firstDot + 1) + digitsAndDot.slice(firstDot + 1).replace(/\./g, '');
    }

    const [intPart, decPart] = digitsAndDot.split('.');
    const limited = decPart !== undefined ? `${intPart}.${decPart.slice(0, 2)}` : intPart;

    return `${negative}${limited}`;
  }
}
